"use strict";
/**
 * This file was automatically generated by joi-to-typescript
 * Do not modify this file manually
 */
Object.defineProperty(exports, "__esModule", { value: true });
